export default __webpack_public_path__ + "static/media/41.5b56c001.png";